import { type FC } from 'react';
import BooleanSelectBox from 'components/molecules/boolean-select-box';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

interface IProps {
  value?: boolean;
  label: string;
  onChange: (e?: boolean) => void;
}

const StatusFilter: FC<IProps> = ({ onChange, value, label }) => {
  const { t } = useTranslation();

  return (
    <div className={s['available-billable-minutes-wrapper']}>
      <label data-cy={`${label}-filter`}>{label}</label>
      <BooleanSelectBox
        withAll
        placeholder={t('labels.all')}
        trueLabel={t('labels.yes')}
        falseLabel={t('labels.no')}
        value={value}
        onChange={onChange}
        allowClear
      />
    </div>
  );
};

export default StatusFilter;
